import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { flagValueToBoolean } from '@app/v2/shared/utils';
import { FeatureFlagsFacade, FlagName } from '@ra-state';
import { Observable, filter, map, of, take, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagGuard {
  private readonly featureFlagsFacade = inject(FeatureFlagsFacade);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const featureFlagName = route.data?.featureFlagName as FlagName | undefined;
    const redirectPath = (route.data?.redirectPath as string | undefined) ?? '/organizations';

    if (!featureFlagName) {
      this.router.navigate([redirectPath]);
      return of(false);
    }

    return this.featureFlagsFacade.getFlagValue$(featureFlagName).pipe(
      filter((flagValue) => flagValue !== undefined),
      take(1),
      map((flagValue) => flagValueToBoolean(flagValue)),
      tap((isEnabled) => {
        if (!isEnabled) {
          this.router.navigate([redirectPath]);
        }
      }),
    );
  }
}
